import {
  NgModule,
  Inject
} from '@angular/core';
import { FEATURE_FORMS } from './tokens';
import { NGXLogger } from 'ngx-logger';
import { DxFormsRootModule } from './forms-root.module';

@NgModule({})
export class DxFormsFeatureModule {
  constructor(
    root: DxFormsRootModule,
    @Inject(FEATURE_FORMS) featureForms: any[][],
    logger: NGXLogger,
  ) {
    logger.trace('[DxFormsFeatureModule::constructor] call', { root, featureForms });
    featureForms.forEach(group =>
      group.forEach(sourceInstance =>
        root.addForm(sourceInstance)
      )
    );
  }
}
